(() => {
  const formatPriceText = (text) =>
    text
      .replace(/€\s*([0-9]+),([0-9]{2})/g, '$1.$2€')
      .replace(/([0-9]+),([0-9]{2})\s*€/g, '$1.$2€');

  const walk = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);

    for (const node of nodes) {
      const current = node.nodeValue || '';
      const next = formatPriceText(current);
      if (next !== current) node.nodeValue = next;
    }
  };

  const run = () => walk(document.body);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
